/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_OpenInputs */

const vi_camera_station_open = /** @type {(inputs: Camera_Station_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera`)
};

/**

* @param {Camera_Station_OpenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_open = /** @type {((inputs?: Camera_Station_OpenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_OpenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_open(inputs)
});